
  <div class="modal-header d-flex align-items-center justify-content-between">
    <h5 class="modal-title" [title]="'ID: ' + shift.id"><span i18n>Order</span>&nbsp;{{ shift.id }}</h5>
    <button type="button" class="btn-close" (click)="activeModal.close()"></button>
  </div>
  <div *ngIf="!show" class="modal-body">
    <div class="text-center" style=" margin-top: calc(50vh - 5rem);">
      <div class="spinner-border" role="status" style="color: var(--primary);"></div>
    </div>
  </div>
  <div *ngIf="show" class="modal-body">
    <form [formGroup]="editForm">
      <div class="container-fluid ps-0 pe-0 mb-3">
        <div class="row align-items-center">
          <div class="col-auto">
            <img [src]="shift.employee.picture"
              style="object-fit: cover; border-radius: 50%; width: 4rem; height: 4rem;" class="me-0">
          </div>
          <div class="col ps-0">
            <span class="float-end">
              <button *ngIf="canShare" (click)="share()" type="button" class="btn btn-primary">
                <fa-icon [icon]="fa.faShareSquare" style="color: #fff; position: relative; top: -1px;"></fa-icon>
              </button>
              &nbsp;
              <button (click)="details()" type="button" class="btn btn-primary">
                <fa-icon [icon]="fa.faInfoCircle" style="color: #fff; position: relative; top: -1px;"></fa-icon>
              </button>
            </span>
            <h5 class="card-title mb-0">
              <span *ngIf="shift.confirmed_customer" class="" title="Confirmed" i18n-title>✓</span>
              <span *ngIf="shift.customer.type != 'individual'">{{ shift.customer.name }}</span> 
              <span *ngIf="shift.employee">{{ shift.employee.first_name }}&nbsp;<span class="text-muted">&bull;</span>&nbsp;</span>
              <span *ngIf="shift.customer.type != 'individual'">{{ shift.customer.name }}&nbsp;&bull;&nbsp;</span> 
              <span>{{ shift.assignment | translateField: 'name' }}</span>
            </h5>
            <div class="text-muted text-nowrap">{{ shift.customer.street_address }} {{ shift.customer.office }} {{ shift.customer.city }}</div>
            <div class="text-muted text-nowrap">{{ shift.start | date: 'EE' }} {{ shift.start | date: 'short' }} - {{ shift.end | date: 'shortTime' }} ({{ msToHumanDuration(shift.duration * 60 * 60 * 1000) }})</div>
            <ng-container *ngIf="shift.checkin_start">
              <div *ngIf="!shift.checkin_end" class="text-success" i18n>In progress</div>
              <div *ngIf="shift.checkin_end" class="text-success" i18n>Completed</div>
            </ng-container>
            <ng-container *ngIf="!shift.checkin_start">
              <div *ngIf="shift.type == 'normal' && shift.confirmed_employee && shift.customer_notified_start" class="" i18n>Partner is on their way</div>
              <div *ngIf="shift.type == 'normal' && shift.confirmed_employee && !shift.customer_notified_start" class="" i18n>Accepted by partner</div>
              <div *ngIf="shift.type == 'normal' && !shift.confirmed_employee && !shift.customer_reminded_start">
                <span class="text-warning" i18n>Waiting for confirmation</span>&nbsp;<span class="text-muted"><ng-container i18n>(deadline:</ng-container>&nbsp;{{
                shift.employee_confirmation_deadline | date: 'shortTime' }})</span>
              </div>
              <div *ngIf="shift.type == 'rejected'" class="text-danger" i18n>Refused by partner</div>
              <div *ngIf="shift.type == 'ignored'" class="text-danger" i18n>Not accepted by partner</div>
              <div *ngIf="shift.type == 'cancelled_customer'" class="text-danger" i18n>Cancelled by customer</div>
              <div *ngIf="shift.type == 'cancelled_employee'" class="text-danger" i18n>Cancelled by partner</div>
              <div *ngIf="shift.type == 'payment_failed'" class="text-danger" i18n>Payment failed</div>
            </ng-container>
          </div>
        </div>
      </div>

      <button class="mb-3 btn btn-primary w-100" (click)="messages(shift)"><span i18n>Chat with partner</span><span
        *ngIf="shift.messages.length > 0">&nbsp;({{ shift.messages.length }})</span></button>

      <div *ngIf="shift.breaks && shift.breaks.length > 0" class="mb-3">
        <h5 class="mt-3" i18n>Breaks</h5>
        <div *ngFor="let break of shift.breaks">
          <div>
            {{ break.start | date:'shortTime' }} - {{ break.end ? (break.end | date:'shortTime') : onGoing }}
            <small class="text-muted">({{ break.type }})</small>
            <span *ngIf="break.duration">
              - {{ msToHumanDuration(break.duration * 60 * 60 * 1000) }}
            </span>
          </div>
        </div>
      </div>
      
      <h5 class="mb-3" i18n>Products and services</h5>
      <div class="card mb-3" *ngFor="let shiftProduct of shift.products | localeSort: 'title'">
        <div class="card-header rounded ps-2 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <img #pictureTag [src]="shiftProduct.product.picture"
              style="object-fit: cover; border-radius: 50%; width: 4rem; height: 4rem;" class="me-2 ms-0">
            <div>
              <div>{{ shiftProduct.number | number: '1.0-2' }} x <strong>{{ shiftProduct | translateField: 'title' }}</strong></div>
              <span class="text-muted">{{ shiftProduct.notes }}</span>
            </div>
          </div>
        </div>
      </div>
      <button *ngIf="shift.is_editable" class="mt-2 mb-3 btn btn-primary w-100" (click)="productAdd(shift.id)" i18n>Add
        product or service</button>

      <button *ngIf="shift.is_editable" type="button" (click)="notes()" class="float-end btn btn-primary"><fa-icon
          [icon]="fa.faPen" style="color: #fff; position: relative; top: -1px;"></fa-icon></button>
      <h5 *ngIf="shift.notes || shift.customer_notes || shift.is_editable" class="" i18n>Notes</h5>
      <span *ngIf="shift.notes" class="mt-3 input-group-text text-start text-pre rounded" style="white-space: pre-wrap;"
        [innerHTML]="shift.notes"></span>
      <span *ngIf="shift.customer_notes" class="mt-3 input-group-text text-start rounded text-pre"
        style="white-space: pre-wrap;" [innerHTML]="shift.customer_notes"></span>

      <!--
    <h5 class="mt-3" *ngIf="shift.tasks.length > 0" i18n>Change requests</h5>
    <div class="card mb-3 cursor-pointer" *ngFor="let task of shift.tasks">
      <div class="card-header">
        {{ task.status | i18nSelect: taskStatuses }} <span class="text-muted float-end">{{ task.created_at | date:
          'short' }}</span>
      </div>
      <div class="card-body ps-2 d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div>
            <div>{{ task.task }}</div>
            <div *ngIf="task.reply">
              <strong i18n>Response</strong><br>
              {{ task.reply }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <table class="table table-dark" *ngIf="shift.tasks.length > 0">
      <thead>
        <tr>
          <th i18n>Sent</th>
          <th i18n>Status</th>
          <th i18n>Request</th>
          <th i18n>Response</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of shift.tasks">
          <td class="align-middle">{{ task.created_at | date: 'short' }}</td>
          <td class="align-middle">{{ task.status | i18nSelect: taskStatuses }}</td>
          <td class="align-middle">{{ task.task }}</td>
          <td class="align-middle">{{ task.reply }}</td>
        </tr>
      </tbody>
    </table>

    <button *ngIf="shift.is_editable" class="mt-2 mb-3 btn btn-primary w-100" (click)="requestChange()" i18n>Request
      other change</button>
    -->

      <button *ngIf="shift.allow_feedback" class="mt-3 btn btn-primary w-100" (click)="feedback(shift)" i18n>Give
        feedback</button>

      <button class="mt-3 btn btn-primary w-100" (click)="copy()" i18n>Order again</button>

      <button *ngIf="shift.allow_canceling" class="mt-3 btn btn-danger w-100" (click)="cancel()"><span
          i18n>Cancel order</span></button>
    </form>
  </div>
